import React, { useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import HomeAddresses from "./HomeAddresses";
import ExpandDiv from "../common/ExpandDiv";
import {
  getFieldName,
  getFieldText,
  getFieldDate,
  getFieldFormattedValue,
} from "../../scripts/helperScripts";
import BintiCaseNotes from "./BintiCaseNotes";

function HomeButtonBar({ application }) {
  const [isOpen, setIsOpen] = useState(false);
  const soarApps = [];

  // const isMountedRef = useRef(true);
  const beds = [];
  const rates = [];
  const correspondence = [];
  const investigations = [];
  // const [toastId, setToastId] = useState();
  const reportOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "SOARLive"
      : "SOARD365Base";

  // useEffect(() => {
  //   return () => (isMountedRef.current = false);
  // }, []);

  // useEffect(() => {
  //   if (
  //     isOpen === true &&
  //     soarApps.length > 0 &&
  //     soarApps[0].fostercarehomeguid &&
  //     isMountedRef.current === true
  //   ) {
  //     loadBeds(soarApps[0].fostercarehomeguid);
  //     loadRates(soarApps[0].fostercarehomeguid);
  //     loadInvestigations(soarApps[0].fostercarehomeguid);
  //     loadCorrespondence(soarApps[0].fostercarehomeguid);
  //     //Get Notes
  //   }
  // }, [isOpen]);

  // const loadBeds = async (fosterHome) => {
  //   await getFosterHomeBeds(fosterHome).then((response) => {
  //     if (response && isMountedRef.current) {
  //       setBeds(response);
  //       toast.success("SOAR Beds Laoded");
  //     }
  //   });
  // };

  // const loadRates = async (fosterHome) => {
  //   await getFosterHomeRates(fosterHome).then((response) => {
  //     if (response && isMountedRef.current) {
  //       setRates(response);
  //       toast.success("SOAR Rates Laoded");
  //     }
  //   });
  // };

  // const loadCorrespondence = async (fosterHome) => {
  //   const tId = toast.loading(`Getting SOAR Correspondence`, {
  //     type: toast.TYPE.SUCCESS,
  //   });

  //   setToastId(tId);
  //   getSoarCorrespondence(fosterHome).then((response) => {
  //     if (response && isMountedRef.current) {
  //       if (response) {
  //         setCorrespondence(response);
  //       }

  //       toast.update(tId, {
  //         render: `SOAR Correspondence loaded.`,
  //         type: toast.TYPE.SUCCESS,
  //         isLoading: false,
  //         autoClose: 5000,
  //         closeOnClick: true,
  //       });

  //       setToastId(undefined);
  //     }
  //   });
  // };

  // const loadInvestigations = async (fosterHome) => {
  //   getFPInvestigations(fosterHome).then((response) => {
  //     if (isMountedRef.current) {
  //       if (response) {
  //         setInvestigations(response);
  //         toast.success("Investigations Loaded");
  //       }
  //     }
  //   });
  // };

  return (
    <>
      {isOpen === true ? (
        <Modal
          size="xl"
          show={isOpen}
          animation={false}
          onHide={() => setIsOpen(false)}
        >
          <Modal.Header closeButton className="bg-safy-info text-white">
            <Modal.Title>{application.id}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {application.HomeData.length > 0 ? (
              <div className="border rounded mb-2 p-2">
                <div className="fw-bold">
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      window.open(
                        `https://family.binti.com/admin/applications/${application.HomeData[0].applicationid}`
                      )
                    }
                  >
                    Open in Binti
                  </button>
                </div>

                {application.HomeData.map((b, index) => (
                  <ExpandDiv
                    className="border rounded bg-light p-1 m-1 fw-normal"
                    title={`${b.type} (${b.status}${
                      b.statusdate
                        ? ` ${new Date(b.statusdate).toLocaleDateString()}`
                        : ""
                    })`}
                    expandStatus={index === 0 ? "expanded" : null}
                    key={`${b.applicationid}${index}`}
                  >
                    <div className="mb-2 text-dark">
                      {/* <div
                        className="bg-safy-info text-white rounded fw-bold p-2 mb-2"
                        role="button"
                        title={`${b.applicationid} - created on ${b.createdon}`}
                        onClick={() => {
                          window.open(
                            `https://family.binti.com/admin/applications/${b.applicationid}`
                          );
                        }}
                      >
                        Open in Binti
                      </div> */}
                      <div className="row mb-2 mx-2">
                        <div className="col">Status</div>
                        <div className="col fw-bold">{b.status}</div>
                        <div className="col">Status Date</div>
                        {b.statusdate ? (
                          <div className="col fw-bold">
                            {new Date(b.statusdate).toLocaleDateString()}
                          </div>
                        ) : (
                          <div className="col"></div>
                        )}
                      </div>
                      <div className="row mb-2 mx-2">
                        <div className="col">Capacity</div>
                        <div className="col fw-bold">
                          {b.capacity ? b.capacity : null}
                        </div>
                        <div className="col">Renewal Due Date</div>
                        <div className="col fw-bold">
                          {b.renewaldate
                            ? new Date(b.renewaldate).toLocaleDateString()
                            : null}
                        </div>
                      </div>
                      <div className="row mb-2 mx-2">
                        <div className="col">
                          {b?.approvedagelower ? "Ages" : null}
                        </div>
                        <div className="col fw-bold">
                          {b.approvedagelower
                            ? `${b.approvedagelower}-${b.approvedagehigher}`
                            : null}
                        </div>
                        <div className="col">Inquiry Date</div>
                        <div className="col fw-bold">
                          {b.inquirydate
                            ? new Date(b.inquirydate).toLocaleDateString()
                            : null}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <div className="mb-1 mx-4 fw-bold">Workers</div>
                          <div className="mb-2 mx-4">
                            {JSON.stringify(b.workers) !== "[{}]" &&
                              b.workers.map((w, index) => (
                                <div key={`${w.id}-${index}`} className="mx-2">
                                  {w.worker_name}
                                </div>
                              ))}
                          </div>
                        </div>
                        <div className="col"></div>
                        <div className="col">Application ID</div>
                        <div className="col">{b.applicationid}</div>
                      </div>
                    </div>
                  </ExpandDiv>
                ))}
                {/* <div className="col">
                    {inRenewalApp.length > 0 ? (
                      <div className="border rounded bg-light mb-2">
                        <div
                          className="bg-safy-info text-white rounded p-2 mb-2"
                          role="button"
                          title={inRenewalApp[0].applicationid}
                          onClick={() => {
                            window.open(
                              `https://family.binti.com/admin/applications/${inRenewalApp[0].applicationid}`
                            );
                          }}
                        >
                          Open In-Renewal Application
                        </div>
                        <div className="row mb-2 mx-2">
                          <div className="col">Renewal Due Date</div>
                          <div className="col fw-bold">
                            {new Date(
                              inRenewalApp[0].renewaldate
                            ).toLocaleDateString()}
                          </div>
                        </div>
                        <div className="mb-1 mx-4 fw-bold">
                          Workers
                        </div>
                        <div className="mb-2 mx-4">
                          {JSON.stringify(inRenewalApp[0].workers) !== "[{}]" &&
                            inRenewalApp[0].workers.map((w, index) => (
                              <div
                                key={`${application.HomeData[0].id}-${index}`}
                                className="mx-2"
                              >
                                {w.worker_name}
                              </div>
                            ))}
                        </div>
                      </div>
                    ) : null}
                  </div> */}
              </div>
            ) : null}
            {soarApps.length > 0 ? (
              <div className="border rounded mb-2">
                <div
                  className="rounded fw-bold bg-safy-info text-white p-2"
                  role="button"
                  onClick={() => {
                    const url =
                      process.env.REACT_APP_ORG +
                      `/main.aspx?etc=10221&extraqs=formid%3da28fd99b-80b7-46a0-9dbc-e83d4d6dffda&id=${soarApps[0].fostercarehomeguid}&pagetype=entityrecord`;
                    window.open(url, "Foster Home");
                  }}
                >
                  SOAR
                </div>
                <div className="p-2">
                  <ExpandDiv title="Beds">
                    {beds
                      .filter((b) => !b.ccx_actualdischarge)
                      .map((bed, index) => (
                        <div
                          className="bg-light rounded border mb-2 p-2"
                          key={`bed-${index}`}
                        >
                          <div>{bed.ccx_name}</div>
                          <div className="row">
                            <div className="col-2">Bed Availability</div>
                            <div className="col-3 fw-bold">
                              {getFieldName(bed.svc_bedavailability)}
                            </div>
                          </div>
                          {bed.ccx_contact ? (
                            <div className="row">
                              <div className="col-2">Client</div>
                              <div className="col-3 fw-bold">
                                <Link
                                  to={`/client/${getFieldText(
                                    bed.ccx_contact
                                  )}`}
                                >
                                  {getFieldName(bed.ccx_contact)}
                                </Link>
                              </div>
                            </div>
                          ) : null}
                          {bed.ccx_actualadmission ? (
                            <div className="row">
                              <div className="col-2">Actual Admission</div>
                              <div className="col-3 fw-bold">
                                {getFieldDate(bed.ccx_actualadmission)}
                              </div>
                            </div>
                          ) : null}
                          {bed.ccx_servicestatuslookup ? (
                            <div className="row">
                              <div className="col-2">Service Status</div>
                              <div className="col-3 fw-bold">
                                {getFieldName(bed.ccx_servicestatuslookup)}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ))}
                  </ExpandDiv>
                  <ExpandDiv title="Rates">
                    {rates
                      .filter((r) => !r.ccx_expirationdate)
                      .map((r, index) => (
                        <div
                          className="bg-light rounded border mb-2 p-2"
                          key={`rate-${index}`}
                        >
                          <div className="row">
                            <div className="col-2">Effective</div>
                            <div className="col-2">
                              {getFieldDate(r.ccx_effectivedate)}
                            </div>
                          </div>
                          {r.sor_tier ? (
                            <div className="row">
                              <div className="col-2">Tier</div>
                              <div className="col-3">
                                {getFieldName(r.sor_tier)}
                              </div>
                            </div>
                          ) : null}
                          {r.ccx_percentage ? (
                            <div className="row">
                              <div className="col-2">Tier</div>
                              <div className="col-3">
                                {getFieldFormattedValue(r.ccx_percentage)}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ))}
                  </ExpandDiv>
                  <ExpandDiv title="Correspondence">
                    {correspondence.map((c, index) => (
                      <div
                        className="bg-light rounded border mb-2 p-2"
                        key={`cor-${index}`}
                      >
                        {/* <SOARCorrespondenceCard correspondence={c} /> */}
                        <div className="row">
                          <div className="col-1">
                            <Link
                              title="SOAR Correspondence"
                              to="/correspondence"
                              state={{
                                correspondence: { correspondence: c },
                                tab: "correspondence",
                              }}
                            >
                              <i className="fas fa-pen p-2"></i>
                            </Link>
                          </div>
                          <div className="col-11">
                            {`${getFieldName(
                              c.sor_servicerecipients
                            )} - ${new Date(
                              c.sor_dateandstarttime["@utc"]
                            ).toLocaleString()}`}
                            {c.sor_progressnote && (
                              <div
                                className="p-2 my-2 border"
                                style={{
                                  backgroundColor: "white",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {c.sor_progressnote}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </ExpandDiv>
                  <ExpandDiv title="Rules Investigations">
                    {investigations.map((i, index) => (
                      <div
                        className="bg-light rounded border mb-2 py-2"
                        key={`inv-${index}`}
                      >
                        <div className="row">
                          <div className="col-1 text-primary">
                            <i
                              className="fas fa-pen px-2 ms-2"
                              onClick={() => {
                                const url =
                                  process.env.REACT_APP_ORG +
                                  "/main.aspx?etc=10539&extraqs=%3f_gridType%3d10539%26etc%3d10539%26id=" +
                                  i.sor_fprulesinvestigationid +
                                  "&pagetype=entityrecord";
                                window.open(url, "FosterHome");
                              }}
                            ></i>
                            <i
                              className="fas fa-print"
                              onClick={() => {
                                const url = `https://safyreports.azurewebsites.net/Reports/Incident/RulesInvestigation/Default?db=${reportOrg}&i=${i.sor_fprulesinvestigationid}`;
                                window.open(
                                  url,
                                  "FP Rules Investigation Report"
                                );
                              }}
                            ></i>
                          </div>
                          <div className="col-11">
                            <div className="row">
                              <div className="col-2">Type</div>
                              <div className="col-2 fw-bold">
                                {i.sor_typeofreview
                                  ? getFieldName(i.sor_typeofreview)
                                  : null}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-2">Date of Violation</div>
                              <div className="col-2 fw-bold">
                                {i.sor_datetimeofviolation
                                  ? getFieldDate(i.sor_datetimeofviolation)
                                  : null}
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-2">SAFY Made Aware</div>
                              <div className="col-2 fw-bold">
                                {i.sor_safymadeaware
                                  ? getFieldDate(i.sor_safymadeaware)
                                  : null}
                              </div>
                            </div>
                            {i.sor_placedonhold ? (
                              <div className="row">
                                <div className="col-2">Home on Hold</div>
                                <div className="col-2 fw-bold">
                                  {getFieldName(i.sor_placedonhold)}
                                </div>
                              </div>
                            ) : null}
                            {i.sor_removedfromhome ? (
                              <div className="row">
                                <div className="col-2">Child(ren) Removed</div>
                                <div className="col-2 fw-bold">
                                  {getFieldName(i.sor_removedfromhome)}
                                </div>
                              </div>
                            ) : null}
                            {i.sor_externalinvestigationinprocess ? (
                              <div className="row">
                                <div className="col-2">
                                  External Investigation
                                </div>
                                <div className="col-2 fw-bold">
                                  {getFieldName(
                                    i.sor_externalinvestigationinprocess
                                  )}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    ))}
                  </ExpandDiv>
                </div>
              </div>
            ) : null}
          </Modal.Body>
        </Modal>
      ) : null}
      <div className="row mt-2 ms-2">
        <div className="col p-0">
          <i
            className="fas fa-home fa-lg"
            role="button"
            title="Open Home"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          ></i>
        </div>
        <div className="col p-0">
          <HomeAddresses application={application} />
        </div>
      </div>
      <div className="row mt-2 ms-2">
        {/* <div className="col p-0">
          <i
            className="fa fa-file fa-lg"
            role="button"
            title="Log Info Session"
          ></i>
        </div> */}
        <div className="col p-0">
          <BintiCaseNotes bintiId={application.id} application={application} />
        </div>
      </div>
    </>
  );
}

export default HomeButtonBar;
